module.exports = __webpack_public_path__ + "static/picture_showcase.d97ce5c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/assets/img/picture_showcase.png
// module id = 571
// module chunks = 111636666260255